import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const ARROW_DOWN_SVG = 'https://cdn.magicpatterns.com/uploads/fnUgBgw9JsLfFkVun5pT6t/sj-website-arrow-down.svg';
const ARROW_UP_SVG = 'https://cdn.magicpatterns.com/uploads/hEP3R4hY8mUGp3Ag3crG84/sj-website-arrow-up.svg';
const ARROW_CIRCLE_SVG = 'https://cdn.magicpatterns.com/uploads/64QdFKsyFH5WUw2eGBDAHS/sj-website-arrow-circle.svg';
export function FAQSection() {
  const faqs = [{
    question: 'Where is your service area?',
    answer: 'Our expert maids are available in urban and suburban areas. Enter your zip code on our booking page to see if we service your specific location.'
  }, {
    question: 'How to book a home or commercial cleaning?',
    answer: 'Booking is easy! Simply click the "Book Now" button, choose your service type, select a date and time, and confirm your details securely online.'
  }, {
    question: 'Do I need to be home when you arrive for the cleaning?',
    answer: 'No, you do not need to be home. You can provide entry instructions (like a lockbox code or hidden key) during the booking process.'
  }, {
    question: 'Do I need to supply the vacuum or cleaning products?',
    answer: 'Our professionals come fully equipped with all necessary cleaning supplies and equipment, including vacuums and eco-friendly products.'
  }, {
    question: 'Do you use eco-friendly cleaning products?',
    answer: 'Yes, we prioritize using safe, eco-friendly cleaning products that are tough on dirt but gentle on your home, family, and pets.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section id="faq" className="bg-white py-24 md:py-32 relative z-20" data-id="element-44">
      <div className="container mx-auto px-6 md:px-12" data-id="element-45">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-start" data-id="element-46">
          {/* Left FAQ Accordion */}
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} className="order-2 lg:order-1" data-id="element-47">
            <div className="space-y-4" data-id="element-48">
              {faqs.map((faq, index) => <div key={index} className="border-b border-gray-200 pb-4" data-id="element-49">
                  <button onClick={() => toggleFAQ(index)} className="w-full flex items-center justify-between py-4 text-left group" data-id="element-50">
                    <h3 className={`text-lg md:text-xl font-bold uppercase tracking-wide transition-colors duration-300 ${openIndex === index ? 'text-accent' : 'text-primary group-hover:text-accent'}`} data-id="element-51">
                      {faq.question}
                    </h3>
                    <img src={openIndex === index ? ARROW_UP_SVG : ARROW_DOWN_SVG} alt="" className="w-5 h-5 shrink-0 ml-4 transition-opacity duration-300" data-id="element-52" />
                  </button>
                  <AnimatePresence data-id="element-53">
                    {openIndex === index && <motion.div initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.3
                }} className="overflow-hidden" data-id="element-54">
                        <p className="text-gray-600 leading-relaxed pb-4 pr-12" data-id="element-55">
                          {faq.answer}
                        </p>
                      </motion.div>}
                  </AnimatePresence>
                </div>)}
            </div>

            <div className="mt-12" data-id="element-56">
              <a href="#" className="inline-flex items-center gap-4 text-primary font-bold uppercase tracking-widest hover:text-accent transition-colors group" data-id="element-57">
                Read all our FAQs
                <img src={ARROW_CIRCLE_SVG} alt="" className="w-12 h-12 group-hover:opacity-80 transition-opacity" data-id="element-58" />
              </a>
            </div>
          </motion.div>

          {/* Right Heading & Image */}
          <motion.div initial={{
          opacity: 0,
          x: 50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="order-1 lg:order-2 flex flex-col items-end text-right" data-id="element-59">
            <h2 className="text-6xl md:text-8xl lg:text-9xl font-heading font-bold text-primary uppercase leading-[0.85] tracking-tighter mb-12" data-id="element-60">
              Frequently <br data-id="element-61" /> Asked <br data-id="element-62" /> Questions
            </h2>

            <div className="relative w-full max-w-md h-[500px] rounded-2xl overflow-hidden shadow-xl" data-id="element-63">
              <img src="https://cdn.magicpatterns.com/uploads/jFqWFePxbYQtHJiGmfrmqN/view-room-interior-with-furniture-copy-space.jpg" alt="Minimalist room with lamp" className="w-full h-full object-cover" data-id="element-64" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}